import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=02bfdc56&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=02bfdc56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/lyb/工作/个人/leo——im/新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bfdc56",
  null
  
)

export default component.exports